import ImpressionLoggerWithCallback from '@/components/common/ImpressionLoggerWithCallback';
import useAuth from '@/hooks/auth/useAuth';
import { BannerAdExchangeModel } from '@/models/ad/list';
import { cn } from '@/utils/style';
import { PropsWithChildren, createContext, useContext } from 'react';

interface Props {
  fallback: React.ReactNode;
  bannerAdExchange: BannerAdExchangeModel | null;
  onImpressionLog: () => void;
}

const BannerAdExchangeContext = createContext<BannerAdExchangeModel | null>(null);

const useBannerAdExchange = () => {
  return useContext(BannerAdExchangeContext);
};

const AdExchangeComponent = ({ children, fallback, bannerAdExchange, onImpressionLog }: PropsWithChildren<Props>) => {
  if (!bannerAdExchange) {
    return <>{fallback}</>;
  }

  return (
    <BannerAdExchangeContext.Provider value={bannerAdExchange}>
      <ImpressionLoggerWithCallback onImpressionLog={onImpressionLog}>
        <div className={'w-full'}>{children}</div>
      </ImpressionLoggerWithCallback>
    </BannerAdExchangeContext.Provider>
  );
};

export default AdExchangeComponent;

const DeliberatedCode = () => {
  const bannerAdExchange = useBannerAdExchange()!;

  return <p className={'typography-ui-10r text-center text-gray-300'}>{bannerAdExchange.deliberatedCode}</p>;
};

const Content = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return <div className={cn('flex w-full flex-col justify-center gap-[8px]', className)}>{children}</div>;
};

const ImageAd = ({
  className,
}: {
  className?: string;
}) => {
  const { token } = useAuth();
  const bannerAdExchange = useBannerAdExchange()!;

  return (
    <img
      onClick={() => bannerAdExchange.action(token)}
      className={cn('cursor-pointer object-contain', className)}
      src={bannerAdExchange.bannerImageUrl!}
      alt={bannerAdExchange.title ?? bannerAdExchange.deliberatedCode ?? ''}
    />
  );
};

AdExchangeComponent.ImageAd = ImageAd;
AdExchangeComponent.Content = Content;
AdExchangeComponent.DeliberatedCode = DeliberatedCode;
